import React from "react";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const Chat = () => {
  const theme = useTheme() || "#3b82f6";
  
  const messages = [
    { id: 1, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 2,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 3,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
    { id: 4, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 5,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 6,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
    { id: 7, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 8,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 9,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
    { id: 10, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 11,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 12,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
    { id: 13, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 14,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 15,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
    { id: 16, text: "Hello Aimee", sender: "system", faded: true },
    {
      id: 17,
      text: " hey there! What can I help you with today",
      sender: "ai",
    },
    {
      id: 18,
      text: "Yes. I just wanted to understand what is your...",
      sender: "user",
      faded: true,
    },
  ];

  return (
    <div className="w-full h-full p-4 overflow-y-auto flex flex-col gap-4 scrollbar-hide">
      {messages.map((msg) => (
        <div
          key={msg.id}
          className={`
            max-w-[85%] px-4 py-3 rounded-2xl text-sm leading-relaxed shadow-md
            ${msg.faded ? 'opacity-50' : 'opacity-100'}
            ${msg.sender === 'user' 
              ? 'ml-auto text-white rounded-br-sm' 
              : msg.sender === 'ai' 
                ? 'mr-auto bg-white text-slate-800 border border-blue-200/50 rounded-bl-sm'
                : 'mx-auto bg-blue-50 text-slate-600 border border-blue-300 text-xs rounded-full px-6 py-1 shadow-none'
            }
          `}
          style={msg.sender === 'user' ? { backgroundColor: theme } : {}}
        >
          {msg.text}
        </div>
      ))}
    </div>
  );
};

export default Chat;
